import BadgeGlobalViewsLogo from "@tSurya/Icons/BadgeGlobalViewsLogo";
import BadgeMgbwLogo from "@tSurya/Icons/BadgeMgbwLogo";
import BadgeSuryaLogo from "@tSurya/Icons/BadgeSuryaLogo";
import React from "react";
import styled from "styled-components";

interface BrandBadgeProps {
    brandName?: string;
}

const StyledBadgeWrapper = styled.div`
    width: 100%;
    svg {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: block;
    }
`;

const normalizeBrandName = (v?: string | null) =>
  (v ?? "").toLowerCase().replace(/\s+/g, "");

const BrandBadge: React.FC<BrandBadgeProps> = ({ brandName = "" }) => {
    const normalizedBrandName = normalizeBrandName(brandName);

    const renderBadge = () => {
        switch (normalizedBrandName) {
            case "surya":
                return <BadgeSuryaLogo />;
            case "globalviews":
                return <BadgeGlobalViewsLogo />;
            case "mg+bw":
            case "mgbw":
                return <BadgeMgbwLogo />;
            default:
                return <BadgeSuryaLogo />;
        }
    };

    return <StyledBadgeWrapper>{renderBadge()}</StyledBadgeWrapper>;
};

export default BrandBadge;